export const CATEGORIES = [
  { slug: "fashion", label: "Fashion" },
  { slug: "music", label: "Music" },
  { slug: "holidays", label: "Holidays" },
  { slug: "cars", label: "Cars" },
  { slug: "technology", label: "Technology" },
  { slug: "future-tech", label: "Future Tech" },
  { slug: "ideas", label: "Ideas" },
  { slug: "gaming", label: "Gaming" },
  { slug: "ink-street", label: "Ink & Street" },
];

export const categoryLabel = (slug) => CATEGORIES.find((c) => c.slug === slug)?.label || slug;
